module.exports = __webpack_public_path__ + "img/arrows-angle-contract.32180757.svg";